import type { MembershipRole } from './seat'

export type MapAccess = 'view_edit' | 'view'

export type PermissionVisibility = 'entire_org' | 'mine'

export type OrgPermissionField =
  | 'mapAccess'
  | 'huntLogVisibility'
  | 'analyticsVisibility'

export type MemberPermissionOverrideValues = {
  mapAccess: MapAccess | null
  huntLogVisibility: PermissionVisibility | null
  analyticsVisibility: PermissionVisibility | null
}

export type MemberPermissionOverride = MemberPermissionOverrideValues & {
  membershipId: string
  userId: string
  role: MembershipRole
  displayName: string
}

export type OrgPermissionSettings = {
  orgId: string
  orgType: 'club' | 'outfitter'
  mapAccess: MapAccess
  huntLogVisibility: PermissionVisibility
  analyticsVisibility: PermissionVisibility
  overrides: MemberPermissionOverride[]
}

const CLUB_OVERRIDABLE_ROLES: readonly MembershipRole[] = ['member']
const OUTFITTER_OVERRIDABLE_ROLES: readonly MembershipRole[] = ['member', 'guide']

export function isOverridableRole(
  role: MembershipRole,
  orgType: 'club' | 'outfitter',
): boolean {
  const allowed =
    orgType === 'outfitter' ? OUTFITTER_OVERRIDABLE_ROLES : CLUB_OVERRIDABLE_ROLES
  return allowed.includes(role)
}

export function isPermissiveValue(
  settings: OrgPermissionSettings,
  field: OrgPermissionField,
): boolean {
  if (field === 'mapAccess') return settings.mapAccess === 'view_edit'
  return settings[field] === 'entire_org'
}
